import { useState } from "react";
import axios from "axios";
import { Send } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL + "/api";

export const SubmitAppForm = ({ onSuccess, compact = false }) => {
  const [formData, setFormData] = useState({
    product_name: "", website_url: "", product_hunt_url: "", tagline: "", description: "",
    launch_date: "", value_orientation: "unknown", governance_framing: "unknown",
    monetization_model: "unknown", founder_composition: "unknown", founder_names: "",
    country: "", ethnicity: "", submitted_by: ""
  });
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await axios.post(`${API}/apps`, formData);
      onSuccess();
    } catch (error) {
      void 0;
    } finally {
      setSubmitting(false);
    }
  };

  const inputClass = "w-full px-3 py-2 bg-background border border-input rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-ring";
  const labelClass = "block text-sm font-medium mb-1.5";

  return (
    <form onSubmit={handleSubmit} className="space-y-4" data-testid="submit-app-form">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className={labelClass}>Product Name *</label>
          <input type="text" required value={formData.product_name} onChange={(e) => setFormData(f => ({ ...f, product_name: e.target.value }))} className={inputClass} data-testid="input-product-name" />
        </div>
        <div>
          <label className={labelClass}>Launch Date *</label>
          <input type="date" required value={formData.launch_date} onChange={(e) => setFormData(f => ({ ...f, launch_date: e.target.value }))} className={inputClass} data-testid="input-launch-date" />
        </div>
      </div>
      <div>
        <label className={labelClass}>Tagline *</label>
        <input type="text" required value={formData.tagline} onChange={(e) => setFormData(f => ({ ...f, tagline: e.target.value }))} placeholder="Brief description of the product" className={inputClass} data-testid="input-tagline" />
      </div>
      <div>
        <label className={labelClass}>Description</label>
        <textarea value={formData.description} onChange={(e) => setFormData(f => ({ ...f, description: e.target.value }))} rows={3} placeholder="Detailed description" className={inputClass} data-testid="input-description" />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className={labelClass}>Website URL</label>
          <input type="url" value={formData.website_url} onChange={(e) => setFormData(f => ({ ...f, website_url: e.target.value }))} placeholder="https://..." className={inputClass} data-testid="input-website-url" />
        </div>
        <div>
          <label className={labelClass}>Product Hunt URL</label>
          <input type="url" value={formData.product_hunt_url} onChange={(e) => setFormData(f => ({ ...f, product_hunt_url: e.target.value }))} placeholder="https://producthunt.com/..." className={inputClass} data-testid="input-ph-url" />
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div>
          <label className={labelClass}>Value Orientation</label>
          <select value={formData.value_orientation} onChange={(e) => setFormData(f => ({ ...f, value_orientation: e.target.value }))} className={inputClass} data-testid="select-orientation">
            <option value="unknown">Unknown</option>
            <option value="care">Care-Centered</option>
            <option value="utility">Utility-Centered</option>
            <option value="creative">Creative</option>
            <option value="extraction">Profit/Extraction</option>
          </select>
        </div>
        <div>
          <label className={labelClass}>Governance Framing</label>
          <select value={formData.governance_framing} onChange={(e) => setFormData(f => ({ ...f, governance_framing: e.target.value }))} className={inputClass} data-testid="select-governance">
            <option value="unknown">Unknown</option>
            <option value="system_aware">System-Aware</option>
            <option value="neutral">Neutral</option>
            <option value="market_first">Market-First</option>
          </select>
        </div>
        <div>
          <label className={labelClass}>Founder Composition</label>
          <select value={formData.founder_composition} onChange={(e) => setFormData(f => ({ ...f, founder_composition: e.target.value }))} className={inputClass} data-testid="select-founders">
            <option value="unknown">Unknown</option>
            <option value="female_only">Female-Only Team</option>
            <option value="male_only">Male-Only Team</option>
            <option value="mixed">Mixed Team</option>
          </select>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className={labelClass}>Country</label>
          <input type="text" value={formData.country} onChange={(e) => setFormData(f => ({ ...f, country: e.target.value }))} placeholder="e.g., USA, India" className={inputClass} data-testid="input-country" />
        </div>
        <div>
          <label className={labelClass}>Founder Names</label>
          <input type="text" value={formData.founder_names} onChange={(e) => setFormData(f => ({ ...f, founder_names: e.target.value }))} placeholder="Comma-separated" className={inputClass} data-testid="input-founder-names" />
        </div>
      </div>
      <button type="submit" disabled={submitting} data-testid="form-submit-btn"
        className="w-full flex items-center justify-center gap-2 px-4 py-3 bg-primary text-primary-foreground rounded-lg hover:bg-primary/90 disabled:opacity-50 font-medium">
        {submitting ? <div className="spinner" /> : <Send className="w-4 h-4" />}
        {submitting ? "Submitting..." : "Submit App"}
      </button>
    </form>
  );
};
